import SEOListContainer from './SEOListContainer';
export default SEOListContainer;
